import Spinner from '../components/Spinner';

const loadingPageStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  zIndex: 9999,
};

const LoadingPage = () => (
  <div style={loadingPageStyle}>
    <Spinner
      animation="border"
      size="sm"
      showSpinner="true"
      displaySize="24px"
      displayText="Redirecting to SierraParts.com..."
    />
  </div>
);

export default LoadingPage;
